import { useState } from "react";
import Alert from "./components/Alert";
import History from "./components/History";
import SourceTab from "./components/SourceTab";
import ChangeSourceModal from "./components/ChangeSourceModal";
import ConfirmModal from "./components/ConfirmModal";
import { useUserInfo } from "../../../../context/user";
import { useOnboardingSources, useSubmitOnboarding } from "../../../../queries/settingsAccount";
import toast from "react-hot-toast";

const ResetContext = () => {
  const [changeSourceModal, setChangeSourceModal] = useState(false);
  const [forceRefreshModal, setForceRefreshModal] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const [loading, setLoading] = useState(false);

  const { data: tableData } = useOnboardingSources(userActiveLocation.id);
  const submitOnboarding = useSubmitOnboarding(userActiveLocation.id);

  const handleOpenChangeSourceModal = () => {
    setChangeSourceModal(!changeSourceModal);
  };

  const handleOpenRefreshModal = () => {
    setForceRefreshModal(!forceRefreshModal);
  };

  const handleConfirmClick = async () => {
    setLoading(true);
    try {
      await submitOnboarding.mutateAsync({
        ...(tableData?.[0]?.website_url
          ? { website_url: tableData?.[0]?.website_url }
          : tableData?.[0]?.file_name
            ? { file_name: tableData?.[0]?.file_name }
            : { form: tableData?.[0]?.form }),
        profileId: userActiveLocation.id,
        username: userActiveLocation.business_name,
      });
    } catch (err) {
      toast.error(err.response.data.error.error || "Failed to load data");
      console.log(err);
    }
    setForceRefreshModal(false);
    setLoading(false);
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-display text-3xl md:text-4xl">Reset Context</h1>
      </div>
      <Alert />
      <SourceTab
        currentSource={tableData?.[0]}
        onChangeSource={handleOpenChangeSourceModal}
        onForceRefresh={handleOpenRefreshModal}
      />
      <History tableData={tableData} />
      <ChangeSourceModal
        isOpen={changeSourceModal}
        onClose={handleOpenChangeSourceModal}
        currentSource={tableData?.[0]}
      />
      <ConfirmModal
        isOpen={forceRefreshModal}
        onClose={handleOpenRefreshModal}
        title="Force Refresh"
        onConfirm={handleConfirmClick}
        loading={loading}
      />
    </div>
  );
};

export default ResetContext;
